export enum UserStreamType {
  HLS = "HLS",
}
